module.exports = __webpack_public_path__ + "static/media/typescript.41fa6ef0.svg";